import { Route, Routes } from "react-router-dom";
import { TestIamActionsQuery } from "~/operations";
import { Space } from "~/lib/types";
import { PageLayout, Redirect } from "~/routes";
import ComplianceEntryPage from "~/entry-pages/space/compliance/ComplianceEntryPage";
import FrameworkEntryPage from "~/entry-pages/space/compliance/[frameworkId]/FrameworkEntryPage";
import FrameworkControlsEntryPage from "~/entry-pages/space/compliance/[frameworkId]/controls/FrameworkControlsEntryPage";
import FrameworkPoliciesEntryPage from "~/entry-pages/space/compliance/[frameworkId]/policies/FrameworkPoliciesEntryPage";
import FrameworkAssetsEntryPage from "~/entry-pages/space/compliance/[frameworkId]/assets/FrameworkAssetsEntryPage";
import FrameworkExceptionsEntryPage from "~/entry-pages/space/compliance/[frameworkId]/exceptions/FrameworkExceptionsEntryPage";
import FrameworkControlEntryPage from "~/entry-pages/space/compliance/[frameworkId]/controls/[controlId]/FrameworkControlEntryPage";
import FrameworkControlChecksEntryPage from "~/entry-pages/space/compliance/[frameworkId]/controls/[controlId]/checks/FrameworkControlChecksEntryPage";
import FrameworkControlDataQueriesEntryPage from "~/entry-pages/space/compliance/[frameworkId]/controls/[controlId]/data-queries/FrameworkControlDataQueriesEntryPage";
import FrameworkControlAssetsEntryPage from "~/entry-pages/space/compliance/[frameworkId]/controls/[controlId]/assets/FrameworkControlAssetsEntryPage";
import FrameworkControlExceptionsEntryPage from "~/entry-pages/space/compliance/[frameworkId]/controls/[controlId]/exceptions/FrameworkControlExceptionsEntryPage";
import FrameworkControlCheckEntryPage from "~/entry-pages/space/compliance/[frameworkId]/controls/[controlId]/check/FrameworkControlCheckEntryPage";
import FrameworkControlDataQueryEntryPage from "~/entry-pages/space/compliance/[frameworkId]/controls/[controlId]/data-query/FrameworkControlDataQueryEntryPage";

type ComplianceRouteProps = {
  space: Space;
};

export function ComplianceRoutes({ space }: ComplianceRouteProps) {
  return (
    <Routes>
      <Route
        path=":frameworkId/controls/:controlId/check"
        element={
          <FrameworkControlCheckEntryPage {...{ space, scope: space }} />
        }
      />
      <Route element={<PageLayout />}>
        <Route index element={<ComplianceEntryPage space={space} />} />
        <Route
          path=":frameworkId"
          element={<FrameworkEntryPage {...{ space }} />}
        >
          <Route index element={<FrameworkControlsEntryPage />} />
          <Route path="controls" element={<FrameworkControlsEntryPage />} />
          <Route path="policies" element={<FrameworkPoliciesEntryPage />} />
          <Route path="assets" element={<FrameworkAssetsEntryPage />} />
          <Route path="exceptions" element={<FrameworkExceptionsEntryPage />} />
        </Route>
        <Route
          path=":frameworkId/controls/:controlId"
          element={<FrameworkControlEntryPage {...{ space }} />}
        >
          <Route index element={<FrameworkControlChecksEntryPage />} />
          <Route path="checks" element={<FrameworkControlChecksEntryPage />} />
          <Route
            path="data-queries"
            element={<FrameworkControlDataQueriesEntryPage />}
          />
          <Route path="assets" element={<FrameworkControlAssetsEntryPage />} />
          <Route
            path="exceptions"
            element={<FrameworkControlExceptionsEntryPage />}
          />
        </Route>
        <Route
          path=":frameworkId/controls/:controlId/data-query"
          element={<FrameworkControlDataQueryEntryPage {...{ space }} />}
        />
        <Route
          path="reports"
          element={
            <Redirect
              from={"space/compliance/reports"}
              to={"space/reporting"}
            />
          }
        />
      </Route>
    </Routes>
  );
}
